import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { InputAdornment, MenuItem, TablePagination } from "@mui/material";
import Loader from "../../../components/common/loader/Loader";
// import { CiFilter } from "react-icons/ci";
import { StyledWelcomeBanner, StyledWrapper } from "../../dashboard/style";
import {
  StyledBoxStyle,
  StyledCustomerSearch,
  StyledOrdersContainer,
  StyledStatusFilter,
  StyledTableLayout,
} from "./style";
import { CUSTOMER_STATUS_FILTER_OPTIONS } from "../../../utils/common";
import {
  StyledSearchIcon,
  StyledTypographyText,
} from "../../virtual-locker/style";
// import { StyledButtonSend } from "../../../components/chat-box/style";
import { CompactStatistics } from "../../../components/admin/dashboard/StatisticsComponent";
import OrderTable from "../../../components/common/table/table";
import { customerStatisticsData, statisticsTitles } from "../../dashboard/constant";
import { CUSTOMER_LIST } from "../../../actions/admin/customer-actions";
// import CircleIcon from '@mui/icons-material/Circle';
// import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import DotIcon from '../../../assets/svg/dot-icon.svg';

const CustomerManagement = () => {
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [statisticsData, setStatisticsData] = useState(customerStatisticsData);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");

  const customerDetails = useCallback(() => {
    dispatch({ type: CUSTOMER_LIST, payload: {
      search : debouncedSearch,
      status: statusFilter,
      page,
      limit: rowsPerPage
    }});
    
  }, [dispatch, debouncedSearch, statusFilter, page, rowsPerPage]);

  useEffect(() => {
    customerDetails();
    
  }, [customerDetails]);

  const {customerList, customerListStatistics, total, isLoading } = useSelector((state) => state?.customer);

  const columns = ["No", "Name", "Email", "Phone", "Locker-ID", "Email Verification", "Status", "Action"];

  const statusColors = {
    Active: { background: "#00C046" }, // green
    Unassigned: { background: "#FF8500" }, // yellow
    Suspended: { background: "#FF3850" }, // red
  };

  const emailVerificationColors = {
    "Yes": { background: "#00C046" },
    "No": { background: "red" },
  };

  const allOrders =
    customerList?.map((item, index) => {
      
      const status = item?.is_suspended === true ? 'Suspended' : 'Active';
      const emailVerificationStatus = item?.is_email_verified === true ? 'Yes' : 'No';
      let virtualLockerStatus = item?.virtual_lockers
      return {
        id: item.id,
        isSuspended: item.is_suspended,
        orderId: (page - 1) * rowsPerPage + index + 1,
        customer: item.name || "-",
        email: item.email?.trim() || "-",
        phone: item.phone_number?.trim() || "-",
        lockerId: item?.virtual_lockers?.[0]?.locker_id || <span
        style={{
          background: "#FF8500",
          fontWeight: "bold",
          display: "inline-flex",
          color: "white",
          padding: "2px 8px 2px 6px",
          borderRadius: "20px",
          minWidth: "90px",
          textAlign: "center",
          alignItems:"center",
          gap:4
        }}
      >
        <img src={DotIcon} alt="" />{virtualLockerStatus}
      </span>,
        emailVerification: (
          <span
            style={{
              background:
                emailVerificationColors[emailVerificationStatus]?.background,
              fontWeight: "bold",
              display: "inline-flex",
              color: "white",
              padding: "2px 8px 2px 6px",
              borderRadius: "20px",
              minWidth: "50px",
              textAlign: "center",
              alignItems:"center",
              gap:5
            }}
          >
          <img src={DotIcon} alt="" />{emailVerificationStatus} 
          </span>
        ),
        status: (
          <span
            style={{
              background: statusColors[status]?.background,
              fontWeight: "bold",
              display: "inline-flex",
              color: "white",
              padding: "2px 8px 2px 6px",
              borderRadius: "20px",
              minWidth: "65px",
              textAlign: "center",
              alignItems:"center",
              gap:5
            }}
          >
          <img src={DotIcon} alt="" />{status} 
          </span>
        ),
        
      }
    }) || [];
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchTerm);
      setPage(1);
    }, 500); // 500ms delay

    return () => {
      clearTimeout(handler); // cleanup on each change
    };
  }, [searchTerm]);

  useEffect(()=>{
    const statisticsData = customerStatisticsData.map((item) => {
      
      switch (item.title) {
        case statisticsTitles.totalCustomers:
          return { ...item, value: customerListStatistics?.total_customers || 0 };
        case statisticsTitles.activeUsers:
          return { ...item, value: customerListStatistics?.active_users || 0 };
        case statisticsTitles.pendingVerification:
          return { ...item, value: customerListStatistics?.pending_verification || 0 };
        default:
          return item;
      }
    });
    setStatisticsData(statisticsData)
    
  }, [customerListStatistics])

  const handleStatusFilterChange = (event) => {
    setStatusFilter(event.target.value);
    setPage(1);
  };

  return (
    <StyledWrapper>
      <StyledWelcomeBanner>
        <CompactStatistics idDataList={statisticsData || []} />
      </StyledWelcomeBanner>

      <StyledTableLayout>
        <StyledTypographyText>CUSTOMER MANAGEMENT</StyledTypographyText>

        <StyledBoxStyle>
          <StyledCustomerSearch
            placeholder="Search by name, email, phone and the locker assignments"
            variant="outlined"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <StyledSearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <StyledStatusFilter
            value={statusFilter}
            onChange={handleStatusFilterChange}
            displayEmpty
            inputProps={{ "aria-label": "Filter by status" }}
          >
            {CUSTOMER_STATUS_FILTER_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </StyledStatusFilter>
        </StyledBoxStyle>

        <StyledOrdersContainer>
          {isLoading ? (
            <Loader />
          ) : (
            <>
              <OrderTable
                columns={columns}
                rows={allOrders}
                customerDetails={customerDetails}
                columnsToHide={["isSuspended", "id"]}
                showCustomerDetailLink
              />
              <TablePagination
                component="div"
                count={total || 0}
                page={page-1}
                onPageChange={(event, newPage) => setPage(newPage + 1)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(event) => {
                  setRowsPerPage(parseInt(event.target.value, 10));
                  setPage(1);
                }}
                rowsPerPageOptions={[5, 10, 25, 50]}
              />
            </>
          )}
        </StyledOrdersContainer>
      </StyledTableLayout>
    </StyledWrapper>
  );
};

export default CustomerManagement;
